import { Component, OnInit } from '@angular/core';
import { overviewgentProps } from 'src/app/interfaces/iresponse';
import { UserService } from 'src/app/services/apiCalls/userService/user.service';

@Component({
  selector: 'app-team-overview-dashboard',
  templateUrl: './team-overview-dashboard.component.html',
  styleUrl: './team-overview-dashboard.component.css'
})
export class TeamOverviewDashboardComponent implements OnInit {

  breadCrumb: any;
  loadingOverView: boolean = false;
  agents: Array<overviewgentProps> = [];
  summary: any = {};
  inactive:number = 0;
  constructor(private userService: UserService){}
  ngOnInit(): void {
    this.breadCrumb  = {
      name: 'Team OverView Dashboard',
      parent: 'Home',
      subLink: null
    };
    this.getTeamOverview();
  }

  getTeamOverview(){
    this.loadingOverView = false;
    return this.userService.getTeamOverview().subscribe({
      next: (response)=>{
        const {agent, summary} = response;
        this.agents = agent;
        this.summary = summary;
        this.inactive = (this.summary.inactive_count - this.summary.agent_count)
      }
    }).add(()=> this.loadingOverView = false)
  }
}
